import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { SchedulerPublicAgentMeetPage } from 'sb-lib/types';
import { getStoredAuthenticationToken } from 'shared/store/storage';
import { TOKEN_AUTHENTICATION_HEADER } from 'shared/utils/authentication-token';
import { store } from 'shared/store';
import { selectActiveOrg } from 'shared/store/auth-slice';

export const orgSchedulerApi = createApi({
  reducerPath: 'org-scheduler-api',
  tagTypes: ['OrgScheduler'],
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/v1/org/scheduler',
    prepareHeaders: headers => {
      const authToken = getStoredAuthenticationToken();
      if (authToken) {
        headers.set(TOKEN_AUTHENTICATION_HEADER, authToken);
      }

      if (store) {
        const orgId = selectActiveOrg(store.getState())?.id;
        if (orgId) {
          headers.set('X-ORG-ID', orgId.toString());
        }
      }
      return headers;
    },
  }),
  endpoints: build => ({
    getOrgAgentPages: build.query<SchedulerPublicAgentMeetPage[], void>({
      query: () => ({ url: '/agent_meet_page', credentials: 'include' }),
      providesTags: ['OrgScheduler'],
    }),
  }),
});

export const { useGetOrgAgentPagesQuery } = orgSchedulerApi;
